import { render, staticRenderFns } from "./IconNavFile.vue?vue&type=template&id=6bca1817&scoped=true&"
import script from "./IconNavFile.vue?vue&type=script&lang=js&"
export * from "./IconNavFile.vue?vue&type=script&lang=js&"
import style0 from "./IconNavFile.vue?vue&type=style&index=0&id=6bca1817&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca1817",
  null
  
)

export default component.exports